import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getAllUsers,
  updateUserRequest,
  deleteUserRequest,
  getCodeRequest,
  changePasswordRequest,
} from "../../services/usersService";
import { getToken } from "../../utils/utility";
import { notification as notifications } from "antd";

export function* getCode(email) {
  try {
    const response = yield call(getCodeRequest, email);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_CODE_SUCCESS,
      });
      notifications["success"]({
        message: "Успешено изпращане.",
      });
    } else if (response[0] === 429) {
      notifications["error"]({
        message: "Грешка",
        description: "Прекалено много заявки. Моля, опитайте по-късно.",
      });
    } else {
      var msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notifications["error"]({
        message: "Грешка, неуспешно изпращане.",
        description: msg,
      });
    }
  } catch (error) {
    notifications["error"]({
      message: "Грешка",
    });
  }
}

export function* changePassword(payload) {
  try {
    const response = yield call(changePasswordRequest, payload);
    if (response[0] === 200) {
      yield put({
        type: actions.CHANGE_PASSWORD_SUCCESS,
      });
      notifications["success"]({
        message: "Успешенa промяна",
      });
    } else {
      var msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notifications["error"]({
        message: "Грешка, неуспешна промяна",
        description: msg,
      });
    }
  } catch (error) {
    notifications["error"]({
      message: "Грешка",
    });
  }
}
export function* getUsers() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllUsers, token);

    if (response[0] === 200) {
      yield put({
        type: actions.GET_USERS_SUCCESS,
        users: response[1],
      });
    } else {
      var msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }

      notifications["error"]({
        message: "Неуспешно взимане на потребители",
        description: msg,
      });
    }
  } catch (error) {
    notifications["error"]({
      message: "Неуспешно взимане на потребители",
    });
  }
}

export function* deleteUser({ user }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(deleteUserRequest, token, user);
    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_USER_SUCCESS,
      });

      notifications["success"]({
        message: "Успешно изтриване.",
      });
    } else {
      var msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }

      notifications["error"]({
        message: "Неуспешено изтриване.",
        description: msg,
      });
    }
  } catch (error) {
    notifications["error"]({
      message: "Неуспешено изтриване.",
    });
  }
}

export function* updateUser({ user }) {
  const token = getToken().get("idToken");
  try {
    const response = yield call(updateUserRequest, user, token);
    if (response[0] === 200) {
      yield put({
        type: actions.UPDATE_USER_SUCCESS,
        user: response[1],
      });
      notifications["success"]({
        message: "Успешен запис",
      });
    } else {
      var msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }

      notifications["error"]({
        message: "Неуспешен запис",
        description: msg,
      });
    }
  } catch (error) {
    notifications["error"]({
      message: "Неуспешен запис",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_USERS_REQUEST, getUsers),
    yield takeEvery(actions.UPDATE_USER_REQUEST, updateUser),
    yield takeEvery(actions.DELETE_USER_REQUEST, deleteUser),
    yield takeEvery(actions.GET_CODE_REQUEST, getCode),
    yield takeEvery(actions.CHANGE_PASSWORD_REQUEST, changePassword),
  ]);
}
